import App from './App.svelte';

particlesJS.load('particles-js', 'assets/particles.json', function () { });

const app = new App({
	target: document.body
});

export default app;